import { useTranslation } from 'react-i18next'

import { HeatGridPlotView, HeatGridPlotViewProps, HeatGridToggleWords } from '@digital-twins/deck-ui/plots/heat-grid'

import { FigurePanel, FigurePanelSections, FigureViewProps } from './figureViewShared'

import { HeatGridData } from '@digital-twins/slide-schemas/generated/plot-types'

/**
 * `heat-grid` on the survey tab, drawn by the kind's plot view (plots plan Q,
 * replacing D3's table seam). Shape only: values, heat (polarity folded in by
 * Python), marks and the Average | Top N stat views are Python's; the plot
 * holds the active tab and opens on `defaultView`. When Python stamped the
 * radar alternative, the view offers the heat / radar toggle in the viewer's
 * language.
 */

function renderHeatPanel(
  panel: FigurePanel,
  locale: string,
  toggleWords: HeatGridToggleWords,
  testIdPrefix: string,
  toggleTestIdPrefix: string | undefined,
  viewport: FigureViewProps['viewport'],
) {
  const plot = { ...panel.plot, props: { locale } } as unknown as HeatGridPlotViewProps['plot']
  return (
    <HeatGridPlotView
      plot={plot}
      viewport={viewport}
      toggleWords={toggleWords}
      testIdPrefix={testIdPrefix}
      toggleTestIdPrefix={toggleTestIdPrefix}
    />
  )
}

export function HeatGridFigure(props: FigureViewProps) {
  const { panels, isCut, locale, viewport } = props

  const { t } = useTranslation('app')

  const testIdPrefix = 'figure-heat-grid'
  const toggleWords = { heat: t('studyReport.plotToggle.heat'), radar: t('studyReport.plotToggle.radar') }

  return (
    <div data-testid={testIdPrefix}>
      <FigurePanelSections
        panels={panels}
        isCut={isCut}
        testIdPrefix={testIdPrefix}
        lowBaseLabel={(panel) => (panel.plot.data as unknown as HeatGridData).labels?.plot_low_base}
        renderPanel={(panel, index) =>
          renderHeatPanel(
            panel,
            locale,
            toggleWords,
            isCut ? `${testIdPrefix}-${index}` : testIdPrefix,
            // Several panels: each toggle keeps its own test ids.
            panels.length > 1 ? `plot-alternative-${index}` : undefined,
            viewport,
          )
        }
      />
    </div>
  )
}
